import React from 'react';
import { Tooltip, Popover, Row, Col, Badge } from 'antd';
import ColorBar from 'react-color-bar';
import RenderCircle from './RenderCircle';
import './progress.css';
import { ExclamationCircleFilled } from '@ant-design/icons';

function ProgressRisk({
  type,
  risks,
  record,
  showPassedPercentage = false,
  showStatistics = false,
}) {
  let data;

  if (type && type === 'risks') {
    let { total, critical, high, medium, low, passed } = risks;
    // let toolDataDot = getTootlip({ high, medium, low, passed });
    data = [
      {
        value: (high / total) * 100,
        color: '#F4657C', // red
      },
      {
        value: (medium / total) * 100,
        color: '#FCDB6B', // yellow
      },
      {
        value: (low / total) * 100,
        color: '#3BA1FF', // blue
      },
      {
        value: (passed / total) * 100,
        color: '#3ADFA3', // green
      },
    ];
    if (high === 0 && medium === 0 && low === 0) {
      data = [
        {
          value: 100,
          color: '#3ADFA3', // green
        },
      ];
    }
    return (
      <div style={{ marginLeft: '10px' }}>
        <Row>
          <Col span={8}>
            <p style={{ display: 'inline-block', lineHeight: 0.9, color: '#8C8C8C' }}>Critical</p>
          </Col>
          <Col span={10} offset={6}>
            <Badge showZero count={critical} overflowCount={1000} color="#F4657C" />
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <p style={{ display: 'inline-block', lineHeight: 0.9, color: '#8c8c8c' }}>High</p>
          </Col>
          <Col span={10} offset={6}>
            <Badge
              showZero
              count={high}
              overflowCount={1000}
              style={{
                color: '#F4657C',
                fontWeight: 600,
                border: '1px solid #F4657C',
                background: 'transparent',
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <p style={{ display: 'inline-block', lineHeight: 0.9, color: '#8c8c8c' }}>Medium</p>
          </Col>
          <Col span={10} offset={6}>
            <Badge
              showZero
              count={medium}
              overflowCount={1000}
              style={{
                color: '#FCDB6B',
                fontWeight: 600,
                border: '1px solid #FCDB6B',
                background: 'transparent',
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col span={8}>
            <p style={{ display: 'inline-block', lineHeight: 0.9, color: '#8c8c8c' }}>Low</p>
          </Col>
          <Col span={10} offset={6}>
            <Badge
              showZero
              count={low}
              overflowCount={1000}
              style={{
                color: '#3BA1FF',
                fontWeight: 600,
                border: '1px solid #3BA1FF',
                background: 'transparent',
              }}
            />
          </Col>
        </Row>

        {/* <Row>
          <Col span={8}>
            <p style={{ display: 'inline-block', lineHeight: 0.9, color: '#8c8c8c' }}>Passed</p>
          </Col>
          <Col span={10} offset={6}>
            <Badge showZero count={passed} overflowCount={1000} color="#3ADFA3" />
          </Col>
        </Row> */}
      </div>
    );
    //       <Popover placement="bottom" content={toolDataDot && toolDataDot}>
    //         <div className="d-flex align-items-center w-100">
    //           <div className="w-100">
    //             <ColorBar
    //               legendContainerStyle={{ display: 'none' }}
    //               barContainerStyle={{ height: 8 }}
    //               data={data}
    //             />
    //           </div>
    //           {showPassedPercentage ? (
    //             <span className="ml-2">{parseInt((passed / total) * 100) || 0}%</span>
    //           ) : showStatistics ? (
    //             <Tooltip title={`${total - passed} risk(s) found`}>
    //               <span className="statistics-container">
    //                 <ExclamationCircleFilled />
    //                 <span>{total - passed + '/' + total}</span>
    //               </span>
    //             </Tooltip>
    //           ) : (
    //             ''
    //           )}
    //         </div>
    //       </Popover>
    //     );
    //   }

    //   if (type && type === 'compliance') {
    //     let { totalRules, rulesPassed } = record;
    //     const percent = (rulesPassed / totalRules) * 100;

    //     data = [
    //       {
    //         value: (rulesPassed / totalRules) * 100,
    //         color: percent <= 33 ? '#F4657C' : percent <= 66 && percent >= 33 ? '#3BA1FF' : '#3ADFA3',
    //       },
    //       {
    //         value: 100 - percent,
    //         color: '#e9e9e9',
    //       },
    //     ];
    //     return (
    //       <Tooltip title={`${Math.round(percent)} %`}>
    //         <div>
    //           <ColorBar
    //             legendContainerStyle={{ display: 'none' }}
    //             barContainerStyle={{ height: 8 }}
    //             data={data}
    //           />
    //         </div>
    //       </Tooltip>
    //     );
  }

  return null;
}

export default ProgressRisk;
